import { makeAutoObservable } from 'mobx';
import { getIsShowed } from './fn/getIsShowed';

export default class LoadingOverlayStore {
    isShowed: boolean = false;

    constructor() {
        this.resetToDefault();
        makeAutoObservable(this);
    }

    resetToDefault() {
        this.isShowed = false;
    }

    getIsShowed = getIsShowed;
}
